import { FC, useEffect, useState } from "react";
import { UnwantedEvent } from "../../types/slices/unwantedEventsType";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectHeaderState } from "../../redux/slices/headerSlice";
import { RoutesMap } from "../../types";
import { Grid } from "@mui/material";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { ApiStatus } from "../../types/api/status";
import { useAuthStore } from "../../hooks";
import { Role } from "../../types/roles/roleTypes";
import { useUnwantedEventStore } from "../../hooks/useUnwantedEvent";
import { useMainStagesWorksStore } from "../../hooks/useMainStagesWorks";

const columns = [
    { type: 'options', field: 'options', label: 'OPCIONES', align: 'center' },
    { type: 'text', field: 'case', label: 'CASOS', align: 'center' },
    { type: 'text', field: 'main_stages', label: 'ETAPAS PRINCIPALES DE TRABAJO', align: 'center', format: (row) => row.main_stages?.map((element) => element).join(' - ') },
    { type: 'detail', field: 'detail', label: '', align: 'center' },
]

const UnwantedEventList: FC = () => {
    const navigate = useNavigate()
    const { user } = useAuthStore()
    const { search } = useSelector(selectHeaderState)
    const { status, unwantedEvents, getUnwantedEvent, deleteUnwantedEventStore, setSelectedUnwantedEvent } = useUnwantedEventStore()
    const { getMainStagesWorks, mainStagesWorks } = useMainStagesWorksStore()

    const [loading, setLoading] = useState<boolean>(false)
    const [page, setPage] = useState<number>(0)
    const [rowsPerPage, setRowsPerPage] = useState<number>(10)
    const [rowSelected, setRowSelected] = useState<UnwantedEvent>({} as UnwantedEvent)
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false)
    const userRole: Role | any = user.userType

    useEffect(() => {
        getUnwantedEventApi()
    }, [search])

    const getUnwantedEventApi = async () => {
        try {
            setLoading(true)
            let payload: any = {}
            if (search !== '') {
                payload = {
                    ...payload,
                    case: search
                }
            }
            await getUnwantedEvent(payload)
            // await getMainStagesWorks()
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }
    }

    const onAdd = () => {
        setSelectedUnwantedEvent({} as UnwantedEvent)
        navigate({ pathname: RoutesMap.UNWANTED_EVENT_FORM })
    }

    const onEdit = (rowSelected) => {
        setSelectedUnwantedEvent(rowSelected)
        navigate({ pathname: RoutesMap.UNWANTED_EVENT_FORM })
    }

    const onDelete = (rowSelected) => {
        setRowSelected(rowSelected)
        setShowModalConfirm(true);
    }

    const onDeleteConfirm = async () => {
        const response = await deleteUnwantedEventStore(rowSelected.id)
        if (response === true) {
            setSelectedUnwantedEvent({} as UnwantedEvent)
            setShowModalConfirm(false)
            getUnwantedEventApi()
        }
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value)
        setPage(0)
    }
    return (
        <>
            <Grid item xs={12}>
                {userRole === Role.ADMIN && (
                    <CustomTable
                        title={'Eventos no deseados'}
                        columns={columns || []}
                        loading={loading}
                        rows={unwantedEvents || []}
                        onRowClick={() => { }}
                        hasOptions
                        onAddFn={onAdd}
                        onEdit={onEdit}
                        onDelete={onDelete}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        handleChangePage={handleChangePage}
                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                )}
                {userRole === Role.MAINTENANCE && (
                    <CustomTable
                        title={'Eventos no deseados'}
                        columns={columns || []}
                        loading={loading}
                        rows={unwantedEvents || []}
                        onRowClick={() => { }}
                        hasOptions
                        onAddFn={onAdd}
                        onEdit={onEdit}
                        onDelete={onDelete}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        handleChangePage={handleChangePage}
                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                )}
            </Grid>
            {
                showModalConfirm && (
                    <ModalConfirm
                        open={showModalConfirm}
                        closeModal={() => { setShowModalConfirm(false) }}
                        onCancel={() => { setShowModalConfirm(false) }}
                        onConfirm={onDeleteConfirm}
                        status2={status === ApiStatus.FETCHING ? true : false}
                    />
                )
            }
        </>
    )
}

export default UnwantedEventList

